// 移植自 crm/src/components/LanguageSwitch.jsx：頂欄語系切換。切換後寫 localStorage 並整頁重載（同舊版）。
import { LanguageIcon, SaveLineIcon } from '@/components/ui/icons'
import { useFocusDropdown } from '@/hooks/useFocusDropdown'

// 複製自 BI 共用的 lib/constants.js（React 版不引用 frontend/lib）
const LANGUAGE_TITLES = { en: 'EN', 'zh-Hant': '繁中', 'zh-Hans': '简中' }
const OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'zh-Hant', label: '繁體中文' },
  { code: 'zh-Hans', label: '简体中文' },
]

// 觸控裝置沒有 hover：dropdown-hover 會「點一下開了又關」。只在滑鼠裝置保留 hover 觸發
const canHover = window.matchMedia('(hover: hover)').matches

function switchLanguage(code) {
  localStorage.lang = code
  document.location.reload()
}

export function LanguageSwitch() {
  // 同舊版：選中狀態只看 localStorage，沒設過就標 English（不看瀏覽器語系）
  const current = localStorage.lang ?? 'en'
  const dd = useFocusDropdown() // Esc 收起選單
  return (
    <div className={`dropdown dropdown-end ${canHover ? 'dropdown-hover' : ''} ${dd.closeClass}`} {...dd.rootProps}>
      <div tabIndex={0} role="button" className="navbar-icon-btn" {...dd.triggerProps} title={LANGUAGE_TITLES[current] ?? current} aria-label="Language">
        <LanguageIcon className="size-4.5" />
      </div>
      {/* daisyUI dropdown 靠 focus-within 開合，選單本身要能聚焦 */}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <ul tabIndex={0} className="dropdown-content lang-menu z-100">
        {OPTIONS.map(({ code, label }) => (
          <li key={code}>
            <button type="button" className={`lang-menu__item ${current === code ? 'is-selected' : ''}`} onClick={() => switchLanguage(code)}>
              <span>{label}</span>
              {current === code && <SaveLineIcon className="size-4 shrink-0 text-white" />}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
